import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const EvacuationLevelPage = () => {
  const columns = [
    { key: 'level', label: 'Level' },
    { key: 'name', label: 'Level Name' },
    { key: 'description', label: 'Description' },
    { key: 'action', label: 'Required Action' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'level', label: 'Level', type: 'text', required: true },
    { key: 'name', label: 'Level Name', type: 'text', required: true },
    { key: 'description', label: 'Description', type: 'textarea', required: false, fullWidth: true },
    { key: 'action', label: 'Required Action', type: 'text', required: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', level: '1', name: 'Normal Operations', description: 'No emergency conditions exist', action: 'Standard protocols', active: 'Yes' },
    { id: '2', level: '2', name: 'Watch', description: 'Potential emergency situation developing', action: 'Monitor and prepare', active: 'Yes' },
    { id: '3', level: '3', name: 'Warning', description: 'Emergency situation imminent or occurring', action: 'Activate emergency plan', active: 'Yes' },
    { id: '4', level: '4', name: 'Evacuation Advisory', description: 'Voluntary evacuation recommended', action: 'Begin patient evacuation', active: 'Yes' },
    { id: '5', level: '5', name: 'Mandatory Evacuation', description: 'Evacuation required by authorities', action: 'Complete evacuation', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Evacuation/Emergency Preparedness Level"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Level"
      formFields={formFields}
      apiEndpoint="/setup/evacuation-level"
    />
  );
};

export default EvacuationLevelPage;
